import type { Action } from './actions'
import type { OperationDeviceCoupon, OperationRepeat } from 'shared/types'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {
    allCoupons: { [string]: Array<OperationDeviceCoupon> },
    showTuto: boolean,
    lastConfirmationChoiceShownAt?: string, //ISO date string
    operationRepeat?: OperationRepeat,
    legalMentionsRoute?: string,
    error?: any,
    networkError?: any
}

const initialState: State = {
    allCoupons: {},
    showTuto: true
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_HOMEPAGE_RESPONSE':
            const { marketingAnimations } = action.data
            const find =
                marketingAnimations &&
                marketingAnimations.primary &&
                marketingAnimations.primary.find(e => {
                    return !!e.operationRepeat
                })
            const operationRepeatPrimary = find
                ? find.operationRepeat
                : undefined
            const operationRepeatWidget =
                marketingAnimations && marketingAnimations.widget
                    ? marketingAnimations.widget.operationRepeat
                    : undefined
            const operationRepeat =
                operationRepeatPrimary || operationRepeatWidget
            return {
                ...state,
                operationRepeat
            }
        case 'MYSTERY_BURGER_SET_OPERATION_REPEAT':
            return { ...state, operationRepeat: action.operationRepeat }
        case 'MYSTERY_BURGER_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.pages.operation.fetch + '/burger-mystere'
            )
        case 'MYSTERY_BURGER_UPDATE_LAST_CONFIRM_MODAL_SHOWN':
            return {
                ...state,
                lastConfirmationChoiceShownAt: new Date().toISOString()
            }
        default:
            return state
    }
}
